import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  mutation MakeUserGlobalAdmin($userId: ID!) {
    makeUserGlobalAdmin(userId: $userId)
  }
`

export const makeUserGlobalAdminKey = getQueryNames(query)[0]

export default query
